import { render, staticRenderFns } from "./summaryReport.vue?vue&type=template&id=0f035cd8&scoped=true"
import script from "./summaryReport.vue?vue&type=script&lang=js"
export * from "./summaryReport.vue?vue&type=script&lang=js"
import style0 from "./summaryReport.vue?vue&type=style&index=0&id=0f035cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f035cd8",
  null
  
)

export default component.exports